export default __webpack_public_path__ + "static/media/check_circle_gray.0d168dc2.svg";